import { createContext } from 'react'

export const HsAppContext = createContext()
